import { PERFORMANCE_DEFAULT_SORTING } from "../../../constants/shared/performanceFilter.constants";

export const individualStorePerformanceConstants = {
  RESTAURANT_EXTERNAL_ID: "RestaurantExternalId",
  GET_ALL_INTERNAL_NOTES: "GET_ALL_INTERNAL_NOTES",
  ALL_USER_RESPONSE_DATA: "ALL_USER_RESPONSE_DATA",
  GET_CUSTOMER_CONVERSATIONS: "GET_CUSTOMER_CONVERSATIONS",
  CUSTOMER_RESPONSES_EXPORT_ALL_DATA: "CUSTOMER_RESPONSES_EXPORT_ALL_DATA",
  STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING:
    "STORES_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING",
  RESET_CUSTOMER_CONVERSATION: "RESET_CUSTOMER_CONVERSATION",
};

export const INDIVIDUAL_STORE_PERFORMANCE_DEFAULT_SORTING =
  PERFORMANCE_DEFAULT_SORTING;

export const INDIVIDUAL_STORE_PERFORMANCE_EXPORT_HEADERS = [
  { label: "NAME", key: "name" },
  { label: "ORDER NUMBER", key: "externalOrderId" },
  { label: "ORDER DATE", key: "orderDate" },
  { label: "SURVEY COMPLETION DATE", key: "surveyCompletionDate" },
  { label: "AVERAGE TRANSACTION RATING", key: "averageGuestTransaction" },
  { label: "AVERAGE SENTIMENT RATING", key: "averageGuestSentiment" },
  { label: "SURVEY COMPLETED", key: "surveysCompleted" },
];
